export const deviceTypes = {
	P4Q: "p4q",
	GAMECHANGE_GEN2: "gen2",
	GAMECHANGE_GEN3: "gen3",
	GAMECHANGE_GEN4: "gen4",
	GAMECHANGE_GEN3_DUAL: "gen3-dual",
	GAMECHANGE_GEN3_DUAL_PRIMARY: "gen3-dual-primary",
	GAMECHANGE_GEN3_DUAL_AUX: "gen3-dual-aux",
}
